export default {

  handleFormValidation() {

    let oForm = $('#form-usuario');

    let aRules = {
      name: {
        required: true
      },
      rut: {
        required: true,
        rut: true
      },
      username: {
        required: true,
        maxlength: 30
      },
      email: {
        required: true,
        email: true
      },
      password: {
        required: false,
        minlength: 4
      },
      password_confirmation: {
        equalTo: '#password'
      }
    };

    let aMessages = {
      name: {
        required: 'El campo Nombre es obligatorio.'
      },
      rut: {
        required: 'El campo RUT es obligatorio.',
        rut: 'El campo RUT tiene un formato inválido.'
      },
      username: {
        required: 'El campo Usuario es obligatorio.',
        maxlength: $.validator.format("El campo Usuario debe tener un máximo de {0} caracteres.")
      },
      email: {
        required: 'El campo E-mail es obligatorio.',
        email: 'El campo E-mail tiene un formato inválido.'
      },
      password: {
        required: 'El campo Contraseña es obligatorio.',
        minlength: $.validator.format("El campo Contraseña debe tener al menos {0} caracteres.")
      },
      password_confirmation: {
        equalTo: 'Las contraseñas con coinciden.'
      }
    };

    if (oForm.length > 0) {
      let oMethod = $('input[name="_method"]', oForm);
      let formMethod = oMethod.length > 0 ? oMethod.val() : 'CREATE';
      // Campos obligatorios para crear un nuevo registro
      if (formMethod === 'CREATE') {
        aRules.password.required = true;
        aRules.password_confirmation.required = true;
      }
    }

    // Validación del formulario
    FormHelper.validate(oForm, aRules, aMessages);
  },

  initCheckBoxes() {
    $('#chkActive').bootstrapSwitch({
      onText: 'SI',
      offText: 'NO'
    });
  },

  initCombos() {
    $('#cmbRoles').select2({
      placeholder: "Seleccionar rol(es)...",
      allowClear: true
    });

    $('#cmbEmpresas').select2({
      placeholder: 'Seleccionar...',
      multiple: true,
      allowClear: true
    });

    $('#cmbTipoJornada').select2({
      placeholder: 'Seleccionar...',
      allowClear: true
    });
  },

  initImagen() {
    $('#btn-eliminarImagen').click(e => {
      e.preventDefault();
      $('input[name="eliminar_imagen"]').val(1);
    });
  },

  initDatePickers() {
    $('.js-datepicker').datepicker({
      orientation: "left",
      autoclose: true,
      format: 'dd/mm/yyyy',
      language: 'es'
    });
  },

  init() {
    this.handleFormValidation();
    this.initCombos();
    this.initCheckBoxes();
    this.initImagen();
    //this.initDatePickers();
  },

  initIndex() {
    this.initCombos();
    FormHelper.handleSearch();
  },

  eliminar(form, nombre) {
    let mensaje = '<p>¿Realmente deseas eliminar al Usuario <strong>' + nombre + '</strong>?</p><p>La acci&oacute;n no podr&aacute; ser revertida.</p>';
    FormHelper.confirm(form, mensaje);
  },

  activar(form, nombre, activar) {
    let msgActivar = activar ? 'activar' : 'desactivar';
    let msgActivar2 = activar ? 'permitir&aacute;' : 'impedir&aacute;';
    let mensaje = '<p>¿Realmente deseas ' + msgActivar + ' al Usuario <strong>' + nombre + '</strong>?</p><p>Esto <strong>' + msgActivar2 + '</strong> que el usuario inicie sesi&oacute;n en el sistema.</p>';
    FormHelper.confirm(form, mensaje);
  },

  suplantar(form, nombre) {
    let mensaje = '<p>¿Realmente deseas iniciar sesión como el Usuario <strong>' + nombre + '</strong>?</p>';
    FormHelper.confirm(form, mensaje);
  }
};
